/* eslint-disable no-unused-vars */
enum en {
  timeToRecord = 'https://storage.googleapis.com/mideoid-console-public/videos/instructional/en/timeToRecord.mp4',
  sampleMIDEO = 'https://storage.googleapis.com/mideoid-console-public/videos/instructional/en/sampleMIDEO.mp4',
}

// type Example = { Example: en };

export const InstructionalVideos = {
  Example: en,
};
